import React from 'react';
import { Sparkles, Monitor, Zap } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_widget-studio-19/artifacts/cfszi269_Firefly_Use%20teh%20clean%20one%20from%20this%20set%20and%20change%20Widgets%20%26%20AI%20Solutions%20to%20AI%20Driven%20Innova%2050267.png";

export const Hero = () => {
  return (
    <section className="relative min-h-[88vh] flex items-center justify-center overflow-hidden hero-gradient">
      <div className="absolute inset-0 z-0 bg-dot-grid opacity-50"></div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-20">
        <div className="flex justify-center mb-10">
          <div className="riveted-frame" data-testid="hero-logo-wrapper">
            <div
              className="w-full max-w-2xl overflow-hidden rounded-[10px]"
              style={{ aspectRatio: '16 / 7' }}
            >
              <img
                src={LOGO_URL}
                alt="LAB21g - AI Driven Innovations"
                className="w-full h-full object-cover"
                style={{ objectPosition: 'center 60%' }}
                data-testid="hero-logo"
              />
            </div>
          </div>
        </div>

        <div className="inline-block mb-7" data-testid="hero-badge">
          <span className="pill">AI Driven Innovation</span>
        </div>

        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 leading-[1.05] tracking-tight" data-testid="hero-heading">
          <span className="text-strong">Build. Automate.</span>{' '}
          <span className="text-gradient-brand">Train.</span>
        </h1>

        <p className="text-base sm:text-lg leading-relaxed text-muted max-w-2xl mx-auto mb-10" data-testid="hero-description">
          Custom Excel sheets, VBA automation, sales data reports, OBS stream widgets, and hands-on
          training for TikTok &amp; eBay LIVE sellers. We build, we share what we know, and sometimes we
          figure it out together.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
          <a
            href="#contact"
            className="btn-primary px-7 py-3.5 inline-flex items-center space-x-2"
            data-testid="hero-cta-button"
          >
            <Sparkles className="w-4 h-4" />
            <span>Get Started</span>
          </a>
          <a
            href="#contact"
            className="btn-secondary px-7 py-3.5 inline-flex items-center space-x-2"
            data-testid="hero-secondary-button"
          >
            <Monitor className="w-4 h-4" />
            <span>Custom Request</span>
          </a>
        </div>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="flex flex-col items-center" data-testid="hero-feature-1">
            <div className="w-11 h-11 rounded-xl border border-default bg-[#111827] flex items-center justify-center mb-4">
              <Zap className="w-5 h-5 accent-green" />
            </div>
            <h3 className="text-lg font-semibold mb-1.5 text-strong">Automate</h3>
            <p className="text-sm text-muted">Excel macros &amp; VBA that save real hours</p>
          </div>
          <div className="flex flex-col items-center" data-testid="hero-feature-2">
            <div className="w-11 h-11 rounded-xl border border-default bg-[#111827] flex items-center justify-center mb-4">
              <Monitor className="w-5 h-5 accent-blue" />
            </div>
            <h3 className="text-lg font-semibold mb-1.5 text-strong">Stream</h3>
            <p className="text-sm text-muted">Secure web widgets for OBS streamers</p>
          </div>
          <div className="flex flex-col items-center" data-testid="hero-feature-3">
            <div className="w-11 h-11 rounded-xl border border-default bg-[#111827] flex items-center justify-center mb-4">
              <Sparkles className="w-5 h-5 accent-green" />
            </div>
            <h3 className="text-lg font-semibold mb-1.5 text-strong">Train</h3>
            <p className="text-sm text-muted">Discover, learn, train — together</p>
          </div>
        </div>
      </div>
    </section>
  );
};
